import React, { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
import { DrawerLayout, UnAuthLayout } from '../components';
import { PATHS } from './paths';
import { OnboardingLayout } from '../components';
import { useIsLoggedIn } from '../hooks/useIsLoggedIn/useIsLoggedIn';

const Integrations = lazy(() => import('../pages/Integrations/Integrations'));

const ContactDetail = lazy(
  () => import('../features/pages/ContactDetail/ContactDetail')
);

const Support = lazy(() => import('../pages/Support/Support'));

// const Referrals = lazy(() => import('../pages/Referrals/Referrals'));
const ClientDetail = lazy(
  () => import('../features/pages/ClientDetail/ClientDetail')
);
const ArchivedClients = lazy(
  () => import('../features/pages/ArchivedClients/ArchivedClients')
);
const Services = lazy(() => import('../pages/Services'));
const Documents = lazy(() => import('../features/pages/Documents'));
const FirmInbox = lazy(() => import('../features/pages/FirmInbox'));
const OnboardingBusiness = lazy(
  () => import('../pages/OnboardingBusiness/OnboardingBusiness')
);
const OnboardingCreationLoader = lazy(
  () => import('../pages/OnboardingCreationLoader/OnboardingCreationLoader')
);

const TemplateDetail = lazy(
  () => import('../pages/TemplateDetail/TemplateDetail')
);

const Plans = lazy(() => import('../pages/Plans/Plans'));
const OnboardingName = lazy(
  () => import('../pages/OnboardingName/OnboardingName')
);
const OnboardingProfileImage = lazy(
  () => import('../pages/OnboardingProfileImage/OnboardingProfileImage')
);
// const Rewards = lazy(() => import('../pages/Rewards/Rewards'));
const Templates = lazy(() => import('../pages/Templates/Templates'));

const ChangePassword = lazy(
  () => import('../pages/ChangePassword/ChangePassword')
);
const Contacts = lazy(() => import('../features/pages/Contacts/Contacts'));
const Home = lazy(() => import('../features/pages/Home/Home'));
const Clients = lazy(() => import('../features/pages/Clients/Clients'));
const Tasks = lazy(() => import('../features/pages/Tasks/Tasks'));
const NotFound = lazy(() => import('../pages/NotFound/NotFound'));
const ResetPassword = lazy(
  () => import('../pages/ResetPassword/ResetPassword')
);
const Settings = lazy(() => import('../pages/Settings/Settings'));
const SignIn = lazy(() => import('../pages/SignIn/SignIn'));
const SignUp = lazy(() => import('../pages/SignUp/SignUp'));
const XeroRedirectContact = lazy(
  () => import('../pages/XeroRedirect/XeroRedirectContact')
);
const XeroRedirectProfile = lazy(
  () => import('../pages/XeroRedirect/XeroRedirectProfile')
);
const XeroRedirectAccounting = lazy(
  () => import('../pages/XeroRedirect/XeroRedirectAccounting')
);

const PaymentMethods = lazy(
  () => import('../pages/PaymentMethods/PaymentMethods')
);

const Account = lazy(() => import('../pages/Account/Account'));
const Business = lazy(() => import('../pages/Business/Business'));
const Notifications = lazy(
  () => import('../pages/Notifications/Notifications')
);
const Security = lazy(() => import('../pages/Security/Security'));
const XeroContacts = lazy(() => import('../pages/XeroContacts/XeroContacts'));
const XeroTransactions = lazy(
  () => import('../pages/XeroTransactions/XeroTransactions')
);
const ReceivingAccounts = lazy(
  () => import('../pages/ReceivingAccounts/ReceivingAccounts')
);
const Transactions = lazy(() => import('../pages/Transactions/Transactions'));
const Users = lazy(() => import('../pages/Users/Users'));
// const GuestPayment = lazy(
//   () => import('../components/GuestPayment/GuestPayment')
// );
// const GuestBindingTasks = lazy(
//   () => import('../components/GuestBindingTasks/GuestBindingTasks')
// );
// const GuestMarkPaid = lazy(
//   () => import('../components/GuestMarkPaid/GuestMarkPaid')
// );
const EntityTaskbox = lazy(
  () => import('../components/EntityTaskbox/EntityTaskbox')
);
const AdmiinAccount = lazy(
  () => import('../pages/AdmiinAccount/AdmiinAccount')
);
const FirmOnboarding = lazy(
  () => import('../pages/FirmOnboarding/FirmOnboarding')
);
const RootRedirect = lazy(
  () => import('../features/pages/RootRedirect/RootRedirect')
);

export const NavRoutes = () => {
  const { isLoggedIn } = useIsLoggedIn();

  return (
    <Routes>
      {/*<Route path={PATHS.payTask} element={<GuestPayment />} />*/}
      {/*<Route path={PATHS.bindingTasks} element={<GuestBindingTasks />} />*/}
      {/*<Route path={PATHS.markTaskPaid} element={<GuestMarkPaid />} />*/}
      <Route path={PATHS.xeroRedirect} element={<XeroRedirectProfile />} />
      <Route path={PATHS.firmOnboarding} element={<FirmOnboarding />} />
      <Route
        path={PATHS.xeroRedirectAccouting}
        element={<XeroRedirectAccounting />}
      />
      <Route
        path={PATHS.xeroRedirectContacts}
        element={<XeroRedirectContact />}
      />
      <Route element={<UnAuthLayout />}>
        {!isLoggedIn && <Route path={PATHS.root} element={<SignIn />} />}
        <Route path={PATHS.resetPassword} element={<ResetPassword />} />
        <Route path={PATHS.signIn} element={<SignIn />} />
        <Route path={PATHS.signUp} element={<SignUp />} />
      </Route>

      <Route element={<OnboardingLayout />}>
        <Route path={PATHS.onboardingName} element={<OnboardingName />} />
        <Route
          path={PATHS.onboardingProfileImage}
          element={<OnboardingProfileImage />}
        />
        <Route
          path={PATHS.onboardingBusiness}
          element={<OnboardingBusiness />}
        />
        <Route
          path={PATHS.onboardingComplete}
          element={<OnboardingCreationLoader />}
        />
      </Route>

      {/*<Route element={<ConversationLayout />}>*/}
      <Route element={<DrawerLayout />}>
        {isLoggedIn && <Route path={PATHS.root} element={<RootRedirect />} />}
        <Route path={PATHS.entitySubRoute} element={<EntityTaskbox />}>
          <Route path={'tasks'} element={<Tasks />}></Route>
        </Route>
        <Route path={PATHS.home} element={<Home />} />
        <Route path={PATHS.services} element={<Services />} />
        <Route path={PATHS.documents} element={<Documents />} />
        <Route path={PATHS.inbox} element={<FirmInbox />} />
        <Route path={PATHS.changePassword} element={<ChangePassword />} />
        <Route path={PATHS.contacts} element={<Contacts />} />
        <Route path={`${PATHS.contacts}/:id`} element={<ContactDetail />} />

        <Route path={PATHS.clients} element={<Clients />}></Route>
        <Route
          path={PATHS.archivedClients}
          element={<ArchivedClients />}
        ></Route>
        <Route path={PATHS.clientDetail} element={<ClientDetail />}></Route>

        <Route path={PATHS.tasks} element={<Tasks />}></Route>
        <Route path={PATHS.admiinAccount} element={<AdmiinAccount />} />
        <Route path={PATHS.settings} element={<Settings />}>
          <Route path={PATHS.account} index element={<Account />} />
          <Route path={PATHS.business} index element={<Business />} />
          <Route
            path={PATHS.settingsChangePassword}
            element={<ChangePassword />}
          />
          <Route path={PATHS.security} element={<Security />} />
          <Route path={PATHS.notifications} element={<Notifications />} />
          <Route path={PATHS.users} element={<Users />} />
          <Route path={PATHS.paymentMethods} element={<PaymentMethods />} />
          <Route
            path={PATHS.receivingAccounts}
            element={<ReceivingAccounts />}
          />
          <Route path={PATHS.transactions} element={<Transactions />} />

          <Route path={PATHS.support} element={<Support />} />
          <Route path={PATHS.integrations} element={<Integrations />} />
        </Route>
        <Route path={PATHS.templates}>
          <Route element={<Templates />}>
            <Route index path=":templateId" element={<TemplateDetail />} />
          </Route>
        </Route>
        <Route path={PATHS.plans}>
          <Route index element={<Plans />} />
        </Route>
        {/*<Route path={PATHS.rewards}>*/}
        {/*  <Route index element={<Rewards />} />*/}
        {/*</Route>*/}
        {/*<Route path={PATHS.referrals} element={<Referrals />} />*/}
      </Route>

      <Route path={PATHS.xeroTransactions} element={<XeroTransactions />} />
      <Route path={PATHS.xeroContacts} element={<XeroContacts />} />

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};
